export enum CampaignStatus {
    ACTIVE = 'ACTIVE',
}

export enum CampaignTaskStatus {
    PENDING = 'PENDING',                        // Pendente
    IN_CONTACT = 'IN_CONTACT',                  // Em Contato
    PROPOSAL_SENT = 'PROPOSAL_SENT',            // Proposta Enviada
    UNDER_NEGOTIATION = 'UNDER_NEGOTIATION',    // Em Negociação
    CLOSED = 'CLOSED',                          // Fechado (ganho)
    LOST = 'LOST'                               // Perdido
}

